import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LoadingSpinnerComponent } from '../loading-spinner/loading-spinner.component';
import { RouterLink } from '@angular/router';
import { NgTemplateOutlet } from '@angular/common';

//TODO: Add start icon, end icon and loading state

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [LoadingSpinnerComponent, RouterLink, NgTemplateOutlet],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  @Input() variant:
    | 'primary-contained'
    | 'secondary-contained'
    | 'outlined'
    | 'link'
    | 'error-link' = 'link';
  @Input() type: 'submit' | 'button' | 'reset' = 'button';
  @Input() size: 'large' | 'medium' = 'large';
  @Input() startIcon?: string;
  @Input() imageIcon?: boolean;
  @Input() link?: string;
  @Input() externalLink?: boolean;
  @Input() query: Record<string, string> = {};
  @Input() endIcon?: string;
  @Input() loading?: boolean;
  @Input() disabled?: boolean;
  @Input() fullWidth?: boolean;
  @Input({ required: true }) label!: string;
  @Output() btnClick = new EventEmitter();

  handleClick() {
    this.btnClick.emit();
  }
}
